module.exports = __webpack_public_path__ + "img/CM.c4087f70.png";